"use client";

import { c as _c } from "react/compiler-runtime";
import type { QuickReplyItem } from "@/lib/chat/messages";
import { QUICK_ACTION_BAR_CLASS, QUICK_ACTION_PILL_CLASS } from "@/components/chat/quickActionStyles";
interface ChatQuickReplyBarProps {
  replies: QuickReplyItem[];
  onSelect: (value: string) => void;
}

/**
 * Full-width quick-reply bar in the chat's bottom slot. Replaces the generic
 * ChatQuickActions once the conversation has started — shares its styling
 * so users recognize it as the same affordance.
 *
 * `key` on the first label re-mounts the container for the fade-in animation
 * whenever a new assistant turn emits a different set of replies.
 */
export function ChatQuickReplyBar(t0) {
  const $ = _c(8);
  const {
    replies,
    onSelect
  } = t0;
  const t1 = replies[0]?.label ?? "";
  let t2;
  if ($[0] !== onSelect || $[1] !== replies) {
    let t3;
    if ($[3] !== onSelect) {
      t3 = (reply, i) => <button key={i} type="button" onClick={() => onSelect(reply.value)} className={QUICK_ACTION_PILL_CLASS}>{reply.label}</button>;
      $[3] = onSelect;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = replies.map(t3);
    $[0] = onSelect;
    $[1] = replies;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div key={t1} className={QUICK_ACTION_BAR_CLASS}>{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}